import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const PartsCategoryLinks = ({ Title, IconURL, URL, ViewAllLinkText, ChildrenCategories }) => {
    
    return (
            <div className="part-category">
                <div className="part-image">
                    <a href={URL}>
                        <img src={IconURL} alt={Title}></img>
                    </a>
                </div>
                <div className="part-list">
                    <Accordion className="part-list-accordion">
                        <AccordionSummary className="part-list-accordion-summary">
                            <strong>
                            <span className="part-list-title">{Title}
                                <ChevronRightIcon className="part-list-expand" />
                            </span>
                            </strong>
                        </AccordionSummary>
                        <AccordionDetails className="part-list-accordion-details">
                            <ul>
                                {ChildrenCategories && ChildrenCategories.map((child) => (
                                    <li key={child.CategoryID}>
                                        <a href={child.URL}>{child.Title}</a>
                                    </li>
                                ))}
                            </ul>
                        </AccordionDetails>
                    </Accordion>
                    {URL && (
                        <ul>
                            <li>
                                <a className="all-btn" href={URL}>{ViewAllLinkText}</a>
                            </li>
                        </ul>
                    )}
                </div>
            </div>
    );
};

export default PartsCategoryLinks;